module.exports = __webpack_public_path__ + "static/img/banner.0f1cf9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.jpg
// module id = omhf
// module chunks = 0